/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MDIStrictHttpResponse } from '../../mdi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MedicalAidModel } from '../../models/medical-aid-model';

export interface MedicalAidIdGet$Params {
  id: string;
}

export function medicalAidIdGet(http: HttpClient, rootUrl: string, params: MedicalAidIdGet$Params, context?: HttpContext): Observable<MDIStrictHttpResponse<MedicalAidModel>> {
  const rb = new RequestBuilder(rootUrl, medicalAidIdGet.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MDIStrictHttpResponse<MedicalAidModel>;
    })
  );
}

medicalAidIdGet.PATH = '/MedicalAid/{id}';
